"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const zustandStore_1 = require("../../zustandStore");
const cookieActions_1 = require("./cookieActions");
const cookieIntroduction_1 = require("./cookieIntroduction");
const cookieManagement_1 = require("./cookieManagement");
const CookieCutter = () => {
    const { cookies, initializeCookiesFromStorage } = (0, zustandStore_1.useZustand)(state => ({
        cookies: state.cookies,
        initializeCookiesFromStorage: state.initializeCookiesFromStorage,
    }));
    const { open, showManageCookies } = cookies;
    (0, react_1.useEffect)(() => {
        if (open) {
            initializeCookiesFromStorage();
        }
    }, [open]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, { "data-testid": "cookie-banner", open: open, disableEscapeKeyDown: true, onClose: () => false, scroll: "body", sx: {
            zIndex: 2000,
            '.MuiDialog-paper': {
                maxWidth: showManageCookies ? '800px' : '500px',
            },
        }, children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { fontWeight: 500, children: "Manage cookie settings" }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { style: { padding: '0 24px', marginBottom: '20px' }, children: showManageCookies ? (0, jsx_runtime_1.jsx)(cookieManagement_1.CookieManagement, {}) : (0, jsx_runtime_1.jsx)(cookieIntroduction_1.CookieIntroduction, {}) }), (0, jsx_runtime_1.jsx)(cookieActions_1.CookieActions, {})] }));
};
exports.default = CookieCutter;
